import { apiRequest } from "./api";

export async function fetchSigninStatus() {
  const payload = await apiRequest("/api/v1/me/signin/status");
  return payload && payload.signin ? payload.signin : null;
}

export async function claimSignin() {
  return apiRequest("/api/v1/me/signin/claim", { method: "POST" });
}
